import React from "react";
import { CTA, Eyebrow, Rise } from "@/components/brand/ui";

const CHOICES = [
  {
    number: "01",
    title: "Apply for a Website Revenue Audit",
    description:
      "Choose this if you’re ready for a structured review of where your website may be losing revenue.",
    to: "/apply",
    variant: "primary",
    testid: "next-step-audit",
  },
  {
    number: "02",
    title: "Book a Fit Call",
    description:
      "Choose this if you’d like to talk through your business and whether an audit is the right next step.",
    calendly: true,
    variant: "ghost",
    testid: "next-step-fit-call",
  },
  {
    number: "03",
    title: "Explore the Field Guide",
    description:
      "Choose this if you’d prefer to explore the TSM Nexus approach before getting in touch.",
    to: "/guide",
    variant: "ghost",
    testid: "next-step-field-guide",
  },
];

export default function ChooseNextStep({ eyebrow, intro, eyebrowSignal = false }) {
  return (
    <section
      aria-labelledby="choose-next-step-heading"
      className="relative overflow-hidden border-t border-white/[0.07] py-16 sm:py-20 md:py-24"
      data-testid="choose-next-step"
    >
      <div
        className="aurora pointer-events-none"
        aria-hidden="true"
        style={{ height: "55vh", inset: "-30% -10% auto -10%" }}
      />
      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-8">
        <Rise className="text-center">
          {eyebrow && <Eyebrow signal={eyebrowSignal}>{eyebrow}</Eyebrow>}
          <h2
            id="choose-next-step-heading"
            className="mx-auto mt-5 font-display font-semibold text-[1.9rem] sm:text-[2.5rem] lg:text-[3rem] leading-[1.06] text-white"
          >
            Choose your next step
          </h2>
          {intro && (
            <p className="mx-auto mt-4 max-w-[58ch] text-[1rem] md:text-lg leading-relaxed text-white/55">
              {intro}
            </p>
          )}
        </Rise>

        <div className="mt-8 grid gap-4 md:mt-10 md:grid-cols-3">
          {CHOICES.map((choice, index) => (
            <Rise key={choice.number} delay={index * 70} className="h-full">
              <article
                className={`flex h-full flex-col rounded-[10px] border p-5 sm:p-6 ${
                  choice.variant === "primary"
                    ? "border-[rgb(var(--brand-cyan)/0.38)] bg-[rgb(var(--brand-cyan)/0.07)]"
                    : "border-white/[0.1] bg-white/[0.025]"
                }`}
              >
                <div className="font-mono text-[10px] font-semibold tracking-[0.22em] text-white/40">
                  {choice.number}
                </div>
                <h3 className="mt-3 font-display font-semibold text-xl leading-snug text-white">
                  {choice.title}
                </h3>
                <p className="mt-2.5 flex-1 text-[14px] leading-relaxed text-white/60">
                  {choice.description}
                </p>
                <div className="mt-6">
                  <CTA
                    to={choice.to}
                    calendly={choice.calendly}
                    variant={choice.variant}
                    testid={choice.testid}
                    className="min-h-12 w-full"
                  >
                    {choice.title}
                  </CTA>
                </div>
              </article>
            </Rise>
          ))}
        </div>
      </div>
    </section>
  );
}
